
import {Component, Prop, Vue} from "vue-property-decorator";
import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
import {IMovementsReport} from "@/modules/Report/Movements/interfaces/movements-report.interface";
import {IApp} from "@/interfaces/app.interface";

type EntityType = IMovementsReport.IDataItem | IMovementsReport.ICarPopupTableItem;

@Component({})
export default class ChangeMovementActionBtn extends Vue {
  @Prop() entity: EntityType;
  @Prop() fromCarPopup!: boolean;
  @Prop() fromSelectMovePopup!: boolean;

  dateFormats = IApp.DateFormats;

  get userAccess(): IAuth.UserAccess { return this.$store.state.auth.userAccess; }

  async openChangeDialog() {
    await this.$store.dispatch('report/openChangeDialog', {
      entity: this.entity,
      fromCarPopup: this.fromCarPopup,
      fromSelectMovePopup: this.fromSelectMovePopup,
    });
  }

}
